import { ThesaurusConceptReference } from '@stylehaven/components';

export interface ThesaurusTreeSelection {
    suggestions: string[];
    type: 'single' | 'multi';
}

export interface ThesaurusTreeSelectionMulti extends ThesaurusTreeSelection {
    type: 'multi';
    concepts: ThesaurusConceptReference[];
}

export interface ThesaurusTreeSelectionSingle extends ThesaurusTreeSelection {
    type: 'single';
    concept: ThesaurusConceptReference | null;
}

export enum ThesaurusTreeSelectionMode {
    ParentSelection = 'parent-selection',
    ConceptSelection = 'concept-selection'
}
